var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShareKeyComponent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8026 13.4198L17.6568 12.5656C19.3652 10.8573 19.3708 8.05711 17.6568 6.34308C15.9484 4.63471 13.1483 4.62905 11.4343 6.34308L10.5801 7.19727",
    stroke: "#7A7A7A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19149 10.5856L6.34296 11.4341C4.62893 13.1482 4.62893 15.9427 6.34296 17.6567C8.05133 19.365 10.8515 19.3707 12.5655 17.6567L13.414 16.8082",
    stroke: "#7A7A7A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7373 14.2627L14.2628 9.73721",
    stroke: "#7A7A7A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShareKeyComponent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share-key-component.ec64ea985e3c6e3bf3dea2215f6abb9c.svg";